module.exports = __webpack_public_path__ + "static/media/pandaisia_thumb2.f57a9b44.jpg";